/* eslint-disable jira/filename-case */
import { fetchJson } from '@atlassian/jira-fetch';
import type { PinnedFieldsForTypeResponse } from './IssueTypesForProjectsResponse.types.tsx';

export const performGetPinnedFieldsForType = ({
	issueTypeId,
	projectId,
}: {
	issueTypeId: string;
	projectId: string;
}): Promise<PinnedFieldsForTypeResponse> =>
	fetchJson<PinnedFieldsForTypeResponse>(
		`/rest/polaris/v2/project/${projectId}/settings/issuetype/${issueTypeId}/pinned-fields`,
	);
